import Vue from 'vue'
import Router from 'vue-router'

import Navbar from './components/Navbar'
import Footer from './components/Footer'

import Landing from './components/views/Landing'
import Privacy from './components/views/Privacy'
import Terms from './components/views/Terms'

// base pages
import DownloadPage from './components/views/traffic/DownloadPage'
import StorePage from './components/views/traffic/StorePage'


Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    // {
    //   path: '/',
    //   name: 'landing',
    //   components: { default: Landing, header: Navbar, footer: Footer},
    //   props: {
    //     header: { transparent: true, logo: false }
    //   }
    // },
    // {
    //   path: '/terms',
    //   name: 'terms',
    //   components: { default: Terms, header: Navbar, footer: Footer}
    // },
    // {
    //   path: '/privacy',
    //   name: 'privacy',
    //   components: { default: Privacy, header: Navbar, footer: Footer}
    // },

    ///////////////////////////////////// Traffic Pages
    // {
    //   path: '/test_download',
    //   name: 'Test Game',
    //   components: { default: DownloadPage },
    //   props: {
    //     default: { 
    //       // required
    //       appName: 'Test Game', 
    //       callbackUrls: ["https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN"],
    //       siteId: "TestSite",
    //       icons: [require('@/assets/store_files/images/hoopstack/icon512.jpg'), require('@/assets/store_files/images/hoopstack/icon512.jpg')],

    //       // pixels
    //       fbPixelId: "596890194430434",
    //     }
    //   }
    // },
    // {
    //   path: '/test_store',
    //   name: 'Test Game',
    //   components: { default: StorePage },
    //   props: {
    //     default: { 
    //       // required
    //       appName: 'Test Game', 
    //       callbackUrl: "https://track.tenjin.io/v0/click/cPZyWZkVr2i3ez55FnKiVN",
    //       siteId: "TestSite",
    //       icon: require('@/assets/store_files/images/hoopstack/icon512.jpg'),
    //       landing: require('@/assets/store_files/images/hoopstack/landing.png'),
    //       long1: require('@/assets/store_files/images/hoopstack/p1.jpg'),
    //       long2: require('@/assets/store_files/images/hoopstack/p2.jpg'),
    //       long3: require('@/assets/store_files/images/hoopstack/p3.jpg'),
    //       long4: require('@/assets/store_files/images/hoopstack/p4.jpg'),
    //       normal1: require('@/assets/store_files/images/hoopstack/1.jpg'),
    //       normal2: require('@/assets/store_files/images/hoopstack/2.jpg'),
    //       normal3: require('@/assets/store_files/images/hoopstack/3.jpg'),
    //       normal4: require('@/assets/store_files/images/hoopstack/4.jpg'),

    //       // pixels
    //       fbPixelId: "596890194430434",

    //       //optionals
    //       appDescription: "Bigger Games",
    //       developer: "Bigger Games",
    //       score: "4.6",
    //       rank: "5",
    //       category: "Puzzle",
    //       age: "4+",
    //       rating: "1.6K",
    //     }
    //   }
    // }

    // {
    //   path: '/cp_download',
    //   name: 'Color Pop Download',
    //   components: { default: DownloadPage },
    //   props: {
    //     default: { 
    //       // required
    //       appName: 'Color Pop', 
    //       callbackUrls: ["https://track.tenjin.io/v0/click/esHaFnjEpyQsezzSCpAThN"],
    //       siteId: "cp_download",
    //       icons: [require('@/assets/store_files/images/colorpop/icon.jpg'), require('@/assets/store_files/images/colorpop/icon.jpg')],

    //       // pixels
    //       fbPixelId: "513712519576903",
    //     }
    //   }
    // }
    







  ]
})



// WEBPACK FOOTER //
// ./src/router.js